import { useTranslation } from 'react-i18next';
import { Waves } from 'lucide-react';
import Section from '@/components/layout/section.tsx';
import SectionTitle from '@/components/layout/section-title.tsx';
import Block from '@/components/layout/block.tsx';

export default function WhatWeProvide() {
	const { t } = useTranslation();

	return (
		<Section className="flex flex-col gap-8 max-lg:gap-4">
			<SectionTitle className="text-[var(--primary)]">{t('what_we_provide.title')}</SectionTitle>

			<div className="flex flex-wrap gap-4">
				<Block
					title={t('services.sound_proofing.title')}
					titleClass="text-[var(--primary)]"
					className="bg-[var(--primary-light)] border-[var(--primary-light)]"
					icon={<img src="/icons/tuning-icon.svg" alt={t('services.sound_proofing.title')} />}
					description={t('services.sound_proofing.description')}
					descriptionClass="text-[var(--primary)]/90"
				/>

				<Block
					title={t('services.detailing.title')}
					titleClass="text-neutral-600"
					className="bg-neutral-200 border-neutral-200"
					icon={<img src="/icons/detailing-icon.svg" alt={t('services.detailing.title')} />}
					description={t('services.detailing.description')}
					descriptionClass="text-neutral-500"
				/>

				<Block
					title={t('services.car_wash.title')}
					titleClass="text-neutral-600"
					className="bg-neutral-50 border-neutral-50"
					icon={<Waves size="1.75rem" />}
					description={t('services.car_wash.description')}
					descriptionClass="text-neutral-500"
				/>
			</div>
		</Section>
	);
}
